export enum AreaModel {
  Simple = 'Simple',
  IncludeBoundaryNodes = 'IncludeBoundaryNodes',
}
